import script from "./PerformanceLeaders.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformanceLeaders.vue?vue&type=script&setup=true&lang=js"

import "./PerformanceLeaders.vue?vue&type=style&index=0&id=3c6f2125&lang=scss"

const __exports__ = script;

export default __exports__